import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const ContentCollectionSidebar = (param)=>{
    let { children, className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("h-full w-full shrink-0 p-2", "md:w-[376px]"),
        children: /*#__PURE__*/ _jsx("aside", {
            className: classNames("flex flex-col rounded-lg border border-grey-5 bg-grey-1 md:h-full md:overflow-y-auto", className),
            ...restOfProps,
            children: children
        })
    });
};
